<template>
  <div class="checkboxes">
    <label v-for="option in options" class="checkbox">
      <input
        type="radio"
        :name="name"
        :value="option"
        v-model="selectedOption"
        @change="onChange(option)"
      />
      <span class="form-checkbox" />
      <span>{{option.label}}</span>
    </label>
  </div>
</template>

<script>
/* Simple, reusable radio button component. Radio buttons are styled as checkboxes. */

export default {
  name: 'CheckboxRadioButtons',
  components: {},
  props: {
    // Unique name that is not shared by any other input on the page
    name: {
      type: String,
      required: true,
    },
    // Array of options. Each option should be an object that has a "label" property
    options: {
      type: Array,
      required: true,
    },
    // Option object that should be initially selected
    initial: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      selectedOption: {},
    }
  },
  created() {
    if (this.initial) {
      this.selectedOption = this.initial
    } else {
      this.selectedOption = this.options[0]
    }
  },
  methods: {
    onChange(option) {
      this.$emit('selected', option)
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';

.checkbox-radio-buttons {
  width: 100%;
}

/* Customize the label (the checkbox-container) */
.checkbox-container {
  display: block;
  position: relative;
  padding: 1.25rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 8px;
  height: 25px;
  width: 25px;
  background-color: $soft-gray;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: $mid-gray;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  background-color: var(--dark-brand-color);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.checkbox-option {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
